import * as Types from '../../../../../../graphql';

import { gql } from '@apollo/client';

/*
* This was automatically generated on by @graphql-codegen.
* DO NOT MANUALLY EDIT !!!
* Please refer to https://github.com/wistia/wistia/blob/main/frontend/graphql/README.md for more information.
* Last Updated: Fri Jul 25 2025 19:42:13 GMT+0000 (Coordinated Universal Time)
*/

export type BrandCustomizationsPartFragment = { __typename?: 'Brand', backgroundColor?: string | null | undefined, darkLogoBakeryHashedId?: string | null | undefined, darkLogoUrl?: string | null | undefined, hasPoweredByWistiaBadge?: boolean | null | undefined, lightLogoBakeryHashedId?: string | null | undefined, lightLogoUrl?: string | null | undefined, primaryColor?: string | null | undefined, secondaryFont?: string | null | undefined, secondaryFontUrl?: string | null | undefined, titleFont?: string | null | undefined, titleFontUrl?: string | null | undefined, titleFontSize?: number | null | undefined, secondaryFontSize?: number | null | undefined, borderRadius?: number | null | undefined, buttonBorderRadius?: number | null | undefined, containerBorderRadius?: number | null | undefined, inputBorderRadius?: number | null | undefined, logoHeight?: number | null | undefined, shouldShowLogo?: boolean | null | undefined, isDarkMode?: boolean | null | undefined, logoTargetUrl?: string | null | undefined };

export const BrandCustomizationsPartFragmentDoc = gql`
    fragment BrandCustomizationsPart on Brand {
  backgroundColor
  darkLogoBakeryHashedId
  darkLogoUrl
  hasPoweredByWistiaBadge
  lightLogoBakeryHashedId
  lightLogoUrl
  primaryColor
  secondaryFont
  secondaryFontUrl
  titleFont
  titleFontUrl
  titleFontSize
  secondaryFontSize
  borderRadius
  buttonBorderRadius
  containerBorderRadius
  inputBorderRadius
  logoHeight
  shouldShowLogo
  isDarkMode
  logoTargetUrl
}
    `;